<app-auth-inner
  *ngIf="!allMessengersService.isAuth;
    else contentRef
  "></app-auth-inner>
<ng-template #contentRef>
  <div class="layout showEffect">
    <app-leads-navbar></app-leads-navbar>
    <div class="main main-leads w-100 vh-100" [class.chat-media-open]="interfaceService.showTabsInput">
      <app-leads-top-bar></app-leads-top-bar>
      <div class="mt-3">
        <ng-template [ngIf]="!allMessengersService.isAuth" [ngIfElse]="contentRef">
          <app-sign-telegram></app-sign-telegram>
        </ng-template>
        <ng-template #contentRef>
          <app-leads-scan-tasks-kanban *ngIf="!(senderService.expiredTariff$ | async); else expiredRef"
                                       (onTaskAdd)="goToTasks()"></app-leads-scan-tasks-kanban>
          <ng-template #expiredRef>
            <div class="text-center h-100 pt-5 px-4">
              <i-feather name="empty" class="big-icon normal"></i-feather>
              <h3 class="text-super-muted mb-4">Продлите тариф...</h3>
              <div class="mb-4 lead-text-info">Для возобновления работы оплатите тариф.<br>
              </div>
              <button (click)="modalService.openModal('ModalLeadsTariffComponent')" nz-button nzType="primary" nzSize="large" nzShape="round">
                Оплатить
                <i-feather name="credit-card" class="ml-2"></i-feather>
              </button>
            </div>
          </ng-template>
        </ng-template>
      </div>
    </div>
    <!-- Main Content -->
  </div>
</ng-template>
